export const styles = {
  input: {
    mb: 1,

    "& .MuiOutlinedInput-root": {
      borderRadius: "100px",
      paddingRight: "4px",

      "& fieldset": {
        borderRadius: "100px",
      },
    },
  },
  button: {
    p: "12px 24px !important",
  },
};
